var exports = {
  "Nr": "VoiceActivityCard.module__card___UmlGZX",
  "wu": "VoiceActivityCard.module__headerContextGroup___UmlGZX",
  "U1": "VoiceActivityCard.module__headerRow___UmlGZX",
  "LD": "VoiceActivityCard.module__headerLeft___UmlGZX",
  "mB": "VoiceActivityCard.module__activityLabel___UmlGZX",
  "l1": "VoiceActivityCard.module__streamingLabel___UmlGZX",
  "kf": "VoiceActivityCard.module__contextButton___UmlGZX",
  "kx": "VoiceActivityCard.module__contextChannelName___UmlGZX",
  "fd": "VoiceActivityCard.module__contextIcon___UmlGZX",
  "gE": "VoiceActivityCard.module__actionIcon___UmlGZX",
  "o_": "VoiceActivityCard.module__contextGuildIcon___UmlGZX",
  "pz": "VoiceActivityCard.module__contextChevron___UmlGZX",
  "mr": "VoiceActivityCard.module__contextDmAvatar___UmlGZX",
  "Nu": "VoiceActivityCard.module__participantsRow___UmlGZX",
  "i1": "VoiceActivityCard.module__previewContainer___UmlGZX",
  "n": "VoiceActivityCard.module__previewSubmitting___UmlGZX",
  "FC": "VoiceActivityCard.module__previewHoverOverlay___UmlGZX",
  "oz": "VoiceActivityCard.module__previewImage___UmlGZX",
  "nZ": "VoiceActivityCard.module__previewFallback___UmlGZX",
  "Mp": "VoiceActivityCard.module__previewHoverText___UmlGZX",
  "$l": "VoiceActivityCard.module__actionRow___UmlGZX",
  "hP": "VoiceActivityCard.module__actionButton___UmlGZX",
};

module.exports = exports;
